// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"d43de855","196":"5446fdec","269":"d3b2251d","303":"89f219c0","308":"7264f855","394":"becefcd7","502":"fb4d64ec","692":"c7ab4def","787":"59b006d2","961":"56d5040e"}[chunkId] + ".chunk.js";
};